// Hexo 风格的 front-matter 解析。只认 Hexo 文章实际会用到的那点 YAML：
// 标量、`[a, b]` 行内数组、`- item` 块数组。不引 js-yaml。
//
//   ---
//   title: Hello World
//   date: 2026-08-05 21:30:00
//   tags: [game, cocos]
//   categories:
//     - Notes
//   ---
//   摘要段落
//   <!-- more -->
//   正文其余部分

const LIST_KEYS = ['tags', 'categories'];

function parseValue(raw) {
  const v = raw.trim().replace(/^["']|["']$/g, '');
  if (v.startsWith('[') && v.endsWith(']')) {
    return v.slice(1, -1).split(',').map(s => s.trim().replace(/^["']|["']$/g, '')).filter(Boolean);
  }
  return v;
}

export function parseFrontMatter(text) {
  const m = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/.exec(text.replace(/^﻿/, ''));
  if (!m) return { data: {}, content: text };

  const data = {};
  let currentKey = null;
  for (const line of m[1].split(/\r?\n/)) {
    const item = /^\s*-\s+(.*)$/.exec(line);
    if (item && currentKey) {
      (data[currentKey] = data[currentKey] || []).push(parseValue(item[1]));
      continue;
    }
    const kv = /^([A-Za-z_][\w-]*):\s*(.*)$/.exec(line);
    if (!kv) continue;
    const [, key, rest] = kv;
    currentKey = key;
    if (rest.trim() === '') {
      // 值在下面的 `- item` 里
      data[key] = LIST_KEYS.includes(key) ? [] : '';
    } else {
      const val = parseValue(rest);
      data[key] = LIST_KEYS.includes(key) && !Array.isArray(val) ? [val] : val;
    }
  }

  return { data, content: m[2] };
}

// Hexo 的摘要分隔符。没有显式 excerpt 时取 <!-- more --> 之前的部分。
export function splitExcerpt(content) {
  const i = content.search(/<!--\s*more\s*-->/i);
  return i === -1
    ? { excerpt: '', body: content }
    : { excerpt: content.slice(0, i).trim(), body: content };
}
